"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconLiveTimeFrame = void 0;
var react_1 = __importDefault(require("react"));
var IconLiveTimeFrame = function (props) { return (react_1.default.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 10 12", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, props),
    react_1.default.createElement("path", { d: "M4.61538 6.09834C5.25 6.09834 5.76923 5.54949 5.76923 4.87867C5.76923 4.20785 5.25 3.659 4.61538 3.659C3.98077 3.659 3.46154 4.20785 3.46154 4.87867C3.46154 5.54949 3.98077 6.09834 4.61538 6.09834ZM4.61538 0C7.03846 0 9.23077 1.96366 9.23077 5.00064C9.23077 6.93991 7.81731 9.22068 4.99615 11.8491C4.77692 12.0503 4.44808 12.0503 4.22885 11.8491C1.41346 9.22068 0 6.93991 0 5.00064C0 1.96366 2.19231 0 4.61538 0Z" }))); };
exports.IconLiveTimeFrame = IconLiveTimeFrame;
